'use client'

import { ChevronUpIcon } from '@heroicons/react/20/solid'
import { getCookie } from 'cookies-next/client'
import { jwtDecode } from 'jwt-decode'
import { usePathname } from 'next/navigation'
import { useEffect, useState } from 'react'
import { useWindowScroll } from 'react-use'
import { twMerge } from 'tailwind-merge'
import { cruzSocket } from '@/socket'
import { useGlobalStore } from '@/store/provider'
import type { Auth } from '@/types'

export default function RootLayoutClient() {
  const pathname = usePathname()
  // to initialize the global user state from the cookie
  const { user, setUser } = useGlobalStore((state) => state)

  useEffect(() => {
    async function initUser() {
      if (!user?.email) {
        const token = getCookie('admin_id_token')
        if (token) {
          const decoded = jwtDecode(token)
          if (decoded) {
            await setUser(decoded as Auth.AdminUser, pathname)
          }
        }
      } else if (!cruzSocket.socket) {
        await setUser(user, pathname)
      }
    }
    initUser()
  }, [])

  // path changed
  useEffect(() => {
    if (cruzSocket.socket) {
      cruzSocket.socket.emit('pathChanged', pathname)
    }
  }, [pathname])

  return <BtnGoTop />
}

const BtnGoTop = () => {
  const [isClient, setIsClient] = useState(false)
  useEffect(() => {
    setIsClient(true)
  }, [])
  const { y } = useWindowScroll()
  if (!isClient) return null
  return (
    <button
      type='button'
      className={twMerge(
        'p-3 fixed bottom-8 right-5 z-50 rounded-full shadow-lg',
        ' bg-zinc-900 hover:bg-zinc-700 text-white dark:bg-zinc-300 dark:hover:bg-zinc-400 dark:text-black',
        'transition duration-400 ',
        y > 200 ? 'opacity-100' : 'opacity-0',
      )}
      onClick={() => {
        window.scrollTo({ top: 0 })
      }}
    >
      <ChevronUpIcon className='size-10' />
    </button>
  )
}
